import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  patientSurgeryByTrack: {
    isLoading: false,
    data: null,
    error: null,
    filters: {
      year: new Date().getFullYear(),
      procedureId: "78763555-39b4-4433-a7f2-079dea69b64a",
    },
  },
  patientSurgeryByAssessmentMade: {
    isLoading: false,
    data: null,
    error: null,
    filters: {
      year: new Date().getFullYear(),
      procedureId: "78763555-39b4-4433-a7f2-079dea69b64a",
    },
  },
  questionSatisfaction: {
    isLoading: false,
    data: null,
    error: null,
    filters: {
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      questionId: "",
    },
  },
};

export const chartSlice = createSlice({
  name: "chart",
  initialState,
  reducers: {
    startLoadingChart: (state, { payload }) => {
      state[payload].isLoading = true;
      state[payload].error = null;
    },
    setChartData: (state, { payload }) => {
      const { chartId, data } = payload;
      state[chartId].isLoading = false;
      state[chartId].data = data;
      state[chartId].error = null;
    },
    setChartError: (state, { payload }) => {
      const { chartId, error } = payload;
      state[chartId].isLoading = false;
      state[chartId].error = error;
    },
    setChartFilter: (state, { payload }) => {
      const { chartId, filterKey, filterValue } = payload;
      if (state[chartId] && state[chartId].filters) {
        state[chartId].filters[filterKey] = filterValue;
        state[chartId].data = null;
      }
    },
  },
});

export const {
  startLoadingChart,
  setChartData,
  setChartError,
  setChartFilter,
} = chartSlice.actions;
